<!-- eslint-disable vue/no-v-html -->
<template>
	<div class="team-cta-slide">
		<div class="cta-top">
			<h3>{{ contact.title }}</h3>
			<div class="mb-5" v-html="contact.text"></div>
		</div>
		<div class="cta-bottom">
			<!-- <a v-if="contact.website" :href="contact.website" class="cta-webseite">
				<font-awesome-icon :icon="['custom', 'share']" />
			</a> -->
			<div class="cta-social">
				<SocialMedia :contact="contact" />
			</div>
		</div>
	</div>
</template>

<script>
import SocialMedia from '../SocialMedia'
export default {
	components: {
		SocialMedia
	},
	// eslint-disable-next-line vue/require-prop-types
	props: ['contact']
}
</script>

<style lang="scss" scoped>
.team-cta-slide {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
	.cta-top {
		min-height: 50vh;
	}
	.cta-bottom {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 30px;
		.cta-webseite {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 20px;
			.fa-share {
				width: 30px;
				height: 30px;
				font-size: 25px;
			}
		}
	}
}
</style>
